import { NgModule } from "@angular/core";
import { BypassSecurityTrustHtml } from "./bypass-security-trust-html.pipe";

@NgModule({
  declarations: [BypassSecurityTrustHtml],
  imports: [],
  exports: [BypassSecurityTrustHtml],
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts